import { Box, Grid2 } from '@mui/material';
import { Dashboard as DashboardLayout } from 'layouts';
import React, { useState } from 'react';
import VideoPlayer from './VideoPlayer';
import List from './List';

export default function Help() {
  const [currentVideo, setCurrentVideo] = useState(null);
  const videos = [];
  const pdf = [];

  const handleVideoClick = (video) => {
    setCurrentVideo(video);
  };

  return (
    <DashboardLayout title="Help">
      <Box sx={{ p: 4 }}>
        <Grid2 container={true} spacing={3}>
          <Grid2 size={{ md: 7, xs: 12 }}>
            <VideoPlayer currentVideo={currentVideo} />
          </Grid2>
          <Grid2 size={{ md: 5, xs: 12 }}>
            <List
              videos={videos}
              onVideoClick={handleVideoClick}
              currentVideo={currentVideo}
              pdf={pdf}
            />
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
}
